import { render, staticRenderFns } from "./ServicePack.vue?vue&type=template&id=107b0ef6"
import script from "./ServicePack.vue?vue&type=script&lang=js"
export * from "./ServicePack.vue?vue&type=script&lang=js"
import style0 from "./ServicePack.vue?vue&type=style&index=0&id=107b0ef6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports